import * as Sentry from "@sentry/react";

import { createSentryAttachment } from "./create-attachment";

export async function captureSentryFeedback({
  eventId,
  message,
  file,
}: {
  eventId: string;
  message: string;
  file?: File;
}) {
  const attachment = file
    ? createSentryAttachment(file.name, await file.arrayBuffer())
    : undefined;

  return Sentry.captureFeedback(
    {
      associatedEventId: eventId,
      message,
      url: window.location.href,
    },
    attachment ? { attachments: [attachment] } : undefined,
  );
}
